import { render, staticRenderFns } from "./WaterMeter.vue?vue&type=template&id=0c4e87cb"
import script from "./WaterMeter.vue?vue&type=script&lang=ts"
export * from "./WaterMeter.vue?vue&type=script&lang=ts"
import style0 from "./WaterMeter.vue?vue&type=style&index=0&id=0c4e87cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports